module.exports = "<input id=\"user_prefs\" [value]=\"jsData\"> <input id=\"user_prefs2\" [value]=\"hdmData\"> ";